// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1HSW4","label":"SetPasswdForm_label__MvHh6"};